import { isNil } from 'lodash';
import { useCallback, useEffect, useState } from 'react';

import useNav from '@src/hooks/useNav';

export type QueryParams = {
  platform: 'publisher' | 'advertiser';
  pid: string;
};

// 将查询参数转换为URLSearchParams
function toSearchParams(params: QueryParams): URLSearchParams {
  const searchParams = new URLSearchParams();

  Object.keys(params).forEach((key) => {
    const item = (params as any)[key];
    if (isNil(item) || item === '') return;
    searchParams.set(key, String(item));
  });

  return searchParams;
}

// 将 url query string 转换为查询参数
function parseQueryParams(queryStr: string, defaultData: QueryParams): QueryParams {
  const result: QueryParams = { ...defaultData };
  const searchParams = new URLSearchParams(queryStr);
  searchParams.forEach((value, key) => {
    if (value === '' || isNil(value)) return;
    if (key === 'platform' && value !== 'publisher' && value !== 'advertiser') return;
    (result as any)[key] = value;
  });
  return result;
}

function useSearch() {
  const nav = useNav();
  const [params, setParams] = useState<QueryParams>(() => parseQueryParams(window.location.search, {
    platform: 'publisher',
    pid: '',
  }));
  const updateParams = useCallback((newParams: Partial<QueryParams>) => {
    const finalParams = { ...params, ...newParams };
    const search = toSearchParams(finalParams);
    nav.to(nav.location.pathname, { search: Object.fromEntries(search) });
    setParams(finalParams);
  }, [nav, params]);

  return { params, updateParams };
}

export default useSearch;